import React from "react";
import { useSilentAppVersionReload } from "@/hooks/useSilentAppVersionReload";

/** Mounts the site-wide deploy auto-reload effect; renders nothing. */
const AppVersionReload: React.FC = () => {
  useSilentAppVersionReload();
  return null;
};

export default AppVersionReload;
